export const defaultText = {
  fontFamily: 'Chakra Petch',
  strokeThickness: 2,
  fontStyle: 'bold',
  fontSize: '20px',
  stroke: '#000',
  resolution: 3,
};